import React, { useState, useEffect } from 'react'
import { Icon, Row } from 'rsuite'
import { requiredFiled, isValidators, getMaxLengthData } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../../widgets/CustomIconMessageInfo'
import ShowLimitLength from '../../../utils/ShowLimitLength'
import ReactQuill, { Quill } from 'react-quill'
import ImageResize from 'quill-image-resize-module-react'
import 'react-quill/dist/quill.snow.css'

Quill.register('modules/imageResize', ImageResize)

export default function ReactQuillFrom({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onChange = () => {},
  toolbars = [['bold', 'italic', 'underline']],
  enableFullScreen = true,
  ...props
}) {
  const keyName = props.name || schema.name
  const maxLength = props.maxLength || getMaxLengthData(schema.validators)?.value
  const isDisabled = props.disabled || schema.disabled

  const [textLength, setTextLength] = useState(props?.value?.length || schema?.value?.length || 0)
  const [textValue, setTextValue] = useState(props.value || schema.value)
  const [validators, setValidators] = useState(schema.validators)
  const [fullscreen, setFullscreen] = useState()

  useEffect(() => {
    setValue(keyName, textValue)
    countText(textValue)
  }, [textValue])

  const modules = {
    toolbar: toolbars,
    imageResize: {
      parchment: Quill.import('parchment'),
      modules: ['Resize', 'DisplaySize', 'Toolbar'],
    },
  }

  const formats = [
    'font',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'align',
    'color',
    'background',
    'size',
  ]

  const containerClassName = `react-quill-container ${fullscreen ? 'fullscreen' : ''}`

  const onEditorChange = (content, delta, source, editor) => {
    var value = editor.getHTML()
    // console.log('value?.length : ', value?.length)
    // console.log('onEditorChange : ', value)

    if (value?.length > 0) {
      // setValue(keyName, value)
      clearErrors(keyName)
      // countText(value)
    } else {
      // setValue(keyName)
      // setTextLength(0)
    }
    setTextValue(value)
    onChange(value)
  }

  // ## ใช้สำหรับแก้ไขเรื่องบันทึกตัวอักษรที่ติด html tag
  const countText = (str) => {
    const text = str?.replace(/<(.|\n)*?>/g, '')

    setTextLength(text?.length || 0)

    if (schema?.validators?.length > 0) {
      if (text?.length <= maxLength) {
        const valid = [schema.validators[0]] || []
        setValidators(valid)
      } else {
        setValidators(schema.validators)
      }
    }
  }

  return (
    <>
      {schema && (
        <>
          <Row style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[keyName]} />
            {schema.label && (
              <p style={{ marginBottom: 10 }}>{requiredFiled(validators, schema.label)}</p>
            )}
            {schema.description && (
              <CustomIconMessageInfo contents={schema.description} style={{ marginBottom: 10 }} />
            )}
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(validators)}
              defaultValue={textValue}
              // value={textValue}
              render={(props) => {
                return (
                  <div className={containerClassName}>
                    <ReactQuill
                      modules={modules}
                      formats={formats}
                      defaultValue={props.value}
                      // value={textValue}
                      readOnly={isDisabled}
                      theme="snow"
                      onChange={onEditorChange}
                    />
                    {enableFullScreen && (
                      <button
                        className="ql-fullscreen"
                        style={{
                          width: '100%',
                          textAlign: 'right',
                          paddingRight: 10,
                        }}
                      >
                        <Icon
                          onClick={() => {
                            setFullscreen(!fullscreen)
                          }}
                          size="1x"
                          icon={fullscreen ? 'compress' : 'expand'}
                        />
                      </button>
                    )}
                  </div>
                )
              }}
            />
          </Row>
          <Row>
            <ShowLimitLength textLength={textLength} maxLength={maxLength} />
          </Row>
        </>
      )}
    </>
  )
}
